import { AppState } from '../meta-reducer/index';
import { ActionReducer, INIT } from '@ngrx/store';
import { logout } from './logout.action';

export function logoutReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
    return (state, action) => {
        if (action != null && action.type === logout.type) {
            return reducer(undefined, { type: INIT });
        }
        return reducer(state, action);
    };
}